import { ModelHelper } from '../classes/model-helper';

export class LabProfileMaterialClass {
	uid: string;
	name: string;
	displayName: string;

	/**
	 *
	 *
	 * Static mapping function
	 *
	 *
	 *
	 * @param data
	 * @param item
	 * @returns LabProfileMaterialClass
	 */
	static map(data: any, item: LabProfileMaterialClass = new LabProfileMaterialClass()): LabProfileMaterialClass {
		return item.map(data);
	}

	/**
	 *
	 *
	 * Non static mapping function
	 *
	 *
	 *
	 * @param data
	 * @return LabProfileMaterialClass
	 */
	public map(data: any): LabProfileMaterialClass {
		ModelHelper.map(data, this, 'uid');
		ModelHelper.map(data, this, 'name');
		ModelHelper.map(data, this, 'displayName');

		// When display name is missing
		if (data['name'] && !this.displayName) {
			ModelHelper.map(data, this, 'displayName', null, 'name');
		}

		return this;
	}
}
